module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-user"
  }, [(_vm.showCloseCross) ? _c('div', {
    staticClass: "active-user__close-cross",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.allUsersInHash[_vm.activeUserId].name))]), _vm._v(" "), _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects'],
      "hoursTitle": "UV",
      "id": "teaching",
      "tasks": _vm.getAllUserSubjectsAndTeachingTasks,
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedTeachingHours(_vm.activeUserId),
      "isTeaching": true,
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditTask,
      "setActiveSubject": _vm.setActiveSubject
    }
  }), _vm._v(" "), _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['additional_tasks'],
      "id": "tasks",
      "hoursTitle": "Øvrig",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksTask,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedTaskHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditTask
    }
  }), _vm._v(" "), _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['preparation'],
      "id": "preperation",
      "hoursTitle": "Forb.",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksPrep,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedPreparationHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditTask
    }
  }), _vm._v(" "), (_vm.getAllUserTasksClub.length > 0) ? _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['club'],
      "id": "club",
      "hoursTitle": "SFO.",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksClub,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedClubHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditTask
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "active-user__agreements"
  }, [_c('SubjectsDistributionUserAgreements', {
    attrs: {
      "userId": _vm.activeUserId
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.theActiveSubject) ? _c('DModal', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        _vm.theActiveSubject = null
      }
    }
  }, [_c('SubjectsDistributionUserEditHours', {
    attrs: {
      "slot": "insertComponent",
      "subject": _vm.getTheActiveSubject,
      "teacher": _vm.getTheActiveUser
    },
    on: {
      "close": function($event) {
        _vm.theActiveSubject = null
      }
    },
    slot: "insertComponent"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        _vm.theActiveSubject = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25fd8e5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionUser.vue
// module id = 1549
// module chunks = 1